import axios from "../../Axios/axiosConfig";

export class PackageService {
    baseUrl;
    packageName;

    constructor(serverUrl, packageName) {
        this.baseUrl = serverUrl;
        this.packageName = packageName
    }

    upgradeDevice = (controlUnitId) => {
        return axios.put(`${this.baseUrl}/api/packages/v0/device/${controlUnitId}/upgrade/${this.packageName}`);
    }

    getLatestUpgradeVersion = () => {
        return axios.get(`${this.baseUrl}/api/packages/v0/latest/${this.packageName}`);
    }

    getUpgradeStatus = (controlUnitId) => {
        return axios.get(`${this.baseUrl}/api/packages/v0/device/${controlUnitId}/upgrade/${this.packageName}/status`);
    }

    getUpgradeProgress = (controlUnitId) => {
        return axios.get(`${this.baseUrl}/api/packages/v0/device/${controlUnitId}/upgrade/${this.packageName}/progress`);
    }
}
